import React, { useEffect, useMemo, useState } from "react";
import { Input, Radio } from "antd";
import {
    EvaluateCan,
    OptionItem,
    RadioEventProps
} from "../../../../../../API/evaluate";
import useDeviceType from "../../../../../../Utils/useDeviceType";
import { RadioChangeEvent } from "antd/es/radio";
import lodash from "lodash-es";
import Style from "./index.module.scss";

interface Props extends RadioEventProps {
    options: OptionItem[];
    disabled?: boolean;
    stuText?: string;
}
const Index = ({
    onChange,
    value,
    options,
    onSave,
    stuText,
    disabled,
    ...restProps
}: Props) => {
    const { isPC } = useDeviceType();

    function radioChange(e: RadioChangeEvent) {
        const item = lodash.find(options, { id: e.target.value });
        if (item) {
            const haveText = item.text === EvaluateCan.Yes;
            onChange?.(e.target.value);
            if (!haveText) {
                onSave(e.target.value);
            }
        }
    }

    const show = useMemo(() => {
        if (typeof value === "string") {
            if (value.includes("dota_Best")) {
                const item = lodash.find(options, {
                    id: value.split("dota_Best")[0]
                }) as OptionItem;
                return item?.text === EvaluateCan.Yes;
            } else {
                const item = lodash.find(options, { id: value }) as OptionItem;
                return item?.text === EvaluateCan.Yes;
            }
        }
    }, [value]);

    const [text, setText] = useState("");
    const [valueId, setValueId] = useState<string | number>("");
    function onBlur() {
        onSave(`${value}dota_Best${text}`);
    }

    useEffect(() => {
        if (value) {
            if (typeof value === "string" && value?.includes("dota_Best")) {
                setValueId(value.split("dota_Best")[0]);
                setText(value.split("dota_Best")[1]);
            } else {
                setValueId(value);
                setText(stuText || "");
            }
        }
    }, [value]);

    return (
        <>
            <div>
                <Radio.Group
                    {...restProps}
                    disabled={disabled}
                    className={Style.row}
                    onChange={radioChange}
                    value={valueId}>
                    {options.map(item => (
                        <React.Fragment key={item.id}>
                            <div className={Style.flex}>
                                <Radio value={item.id}>
                                    {item.description}
                                </Radio>
                                {show && valueId === item.id && (
                                    <div className={Style.input}>
                                        <Input.TextArea
                                            disabled={disabled}
                                            placeholder={item?.ckdesc}
                                            onChange={e =>
                                                setText(e.target.value)
                                            }
                                            onBlur={onBlur}
                                            value={text}
                                            rows={4}
                                        />
                                        <span className={Style.length}>
                                            已输入 {text.length} 字
                                        </span>
                                    </div>
                                )}
                            </div>
                            {show && valueId === item.id && (
                                <div className={Style.hr} />
                            )}
                        </React.Fragment>
                    ))}
                </Radio.Group>
            </div>
        </>
    );
};

export default Index;
